import "./style.css";

function MobilePw({
  powerliftingDescription1,
  powerliftingDescription2,
  squatDescription1,
  squatDescription2,
  squatImage,
  benchDescription1,
  benchDescription2,
  benchImage,
  deadliftDescription1,
  deadliftDescription2,
  deadliftImage,
}: any) {
  return (
    <div id="mobile-pw" className="mobile-pw-area">
      <div className="mobile-pw-content">
        <h2 className="mobile-pw-title">ERŐEMELÉS</h2>
        <h1 className="mobile-pw-title2">A SZAK-</h1>
        <h1 className="mobile-pw-title2">TERÜLETÜNK</h1>
        <div className="mobile-pw-text-columns">
          <div className="mobile-pw-column">
            <p>{powerliftingDescription1}</p>
          </div>
        </div>

        <div className="mobile-pw-boxes">
          <div className="mobile-pw-box">
            <div className="mobile-pw-image">
              <img src={squatImage} alt="Bench Press"></img>
            </div>
            <div className="mobile-pw-description">
              <h3 className="mobile-pw-box-title">
                Miért ajánljuk az erőemelést mint versenysportot?
              </h3>
              <p>{squatDescription1}</p>
              <br />
              <p>{squatDescription2}</p>
            </div>
          </div>

          <div className="mobile-pw-box">
            <div className="mobile-pw-image">
              <img src={benchImage} alt="Bench Press"></img>
            </div>
            <div className="mobile-pw-description">
              <h3 className="mobile-pw-box-title">
                Miért ajánljuk hobbi sportnak?
              </h3>
              <p>{benchDescription1}</p>
              <br />
              <p>{benchDescription2}</p>
            </div>
          </div>

          <div className="mobile-pw-box">
            <div className="mobile-pw-image">
              <img src={deadliftImage} alt="Deadlift"></img>
            </div>
            <div className="mobile-pw-description">
              <h3 className="mobile-pw-box-title">
                Miért jó kiegészítőnek más sportokhoz?{" "}
              </h3>
              <p>{deadliftDescription1}</p>
              <br />
              <p>{deadliftDescription2}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobilePw;
